export default {
  // route: {
  //   home: 'Home',
  //   profile: 'Profile',
  //   history: 'History'
  // },
  menu:{
    services: 'Services',
    mobile_topup: 'Mobile Topup',
    egift: 'Egift',
    about: 'About',
    our_company: 'Our Company',
    terms_and_conditions: 'Terms And Conditions',
    about_shopicel: 'About Shopicel',
    faqs: 'FAQ',
    follow_us: 'Follow Us',
    contact_us: 'Contact Us',
    lock_screen: 'Lock Screen',
    logout: 'Logout'
  },

  // navbar: {
  //   logOut: 'Log Out',
  //   dashboard: 'Dashboard',
  //   github: 'Github',
  //   screenfull: 'screenfull',
  //   theme: 'theme'
  // },
  // register:{
  //   subheader: 'Register for free and enjoy the services today',
  //   feature1_title: 'Free Account',
  //   feature1_desc: 'Here you can write a feature description for your app, let the users know what is the value that you give them',
  //   feature2_title: 'Awesome Performacens',
  //   feature2_desc: 'Here you can write a feature description for your app, let the users know what is the value that you give them',
  //   feature3_title: 'Global Support',
  //   feature3_desc: 'Here you can write a feature description for your app, let the users know what is the value that you give them'
  // },
  label:{
    sign_up: 'Sign Up',
    sign_in: 'Sign In',
    sign_out: 'Sign Out',
    my_account: 'My Account',
    email: 'Email',
    service: 'Service',
    from_date: 'From',
    to_date: 'To',
    from: 'From',
    to: 'To',
    email_address: 'Email Address',
    name: 'Name',
    first_name: 'First Name',
    last_name: 'Last Name',
    language: 'Language',
    country: 'Country',
    dob: 'Day Of Birth',
    phone: 'Phone',
    password: 'Password',
    password_confirmation: 'Password Confirmation',
    subscribe_to_newsletter: 'Subscribe To Newsletter',
    forgot_password: 'Forgot your password?',
    edit_profile: 'Edit Profile',
    contacts: 'Contacts',
    history: 'History',
    date: 'Date',
    no_transactions: 'No transactions',
    loading_data: 'Loading Data',
    view: 'View',
    login: 'Login',
    register: 'Register',
    create_contact: 'Create Contact',
    update_contact: 'Update Contact',
    use_existing: 'Use Existing',
    edit: 'Edit',
    delete: 'Delete',
    sender_phone: 'Sender Phone Number',
    receiver_phone: 'Receiver Phone Number',
    receiver_country: 'Receiver Country',
    read: 'Read',
    terms_and_conditions: 'Terms and Conditions',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    domestic_mobile_top_up: 'Domestic Mobile TopUp',
    international_calls: 'International Calls',
    mobile_top_up: 'Mobile Top Up',
    international_egift: 'International Egift',
    money_transfer: 'Money Transfer',
    change_password: 'Change Password',
    update_password: 'Update Password',
    for_more_information: 'For More Information',
    call_customer_assistance: 'Call Customer Assistance',
    send_email_to: 'Send Email To',
    subscribe: 'Subscribe',
    subject: 'Subject',
    pick_a_day: 'Pick a Day'

  },
  header:{
    login: 'Login'
  },
  button:{
    create_account: 'Create Free Account',
    add: 'Add',
    save: 'Save',
    cancel: 'Cancel',
    login: 'Login',
    register: 'Register',
    update_profile: 'Update Profile',
    update: 'Update',
    filter: 'Filter',
    add_contact: 'Add Contact',
    submit: 'Submit'

  },
  message:{
    login_register_message: 'Don\'t have an account?',
    create_one_here: 'Create one here',
    register_login_message: 'Already have an account?',
    click_here_to_login: 'Click here to login',
    forgot_password: 'Forgot Password or Security Code?',
    error_creating_contact: 'Error creating contact',
    error_updating_contact: 'Error updating contact',
    error_deleting_contact: 'Error deleting contact',
    error_updating_password: 'Error updating password',
    password_updated: 'Password updated successfully',

    accept_topup_terms_and_conditions: 'Acept terms and conditions',

    auth_sign_in_error: 'Error authenticating user',
    auth_sign_up_error: 'Error signing up user',

  },

  auth:{
    weak_password: 'Password should be at least 6 characters',
    wrong_password: 'The password is invalid or the user does not have a password',
    email_already_in_use: 'The email address is already in use by another account',
    requires_recent_login: 'This operation is sensitive and requires recent authentication. Log in again before retrying this request',
    popup_closed_by_user: 'The popup has been closed by the user before finalizing the operation'
  },

  faqPage:{
    title: 'Frequently Asked Questions',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ut pellentesque era'
  },
  contactPage:{
    title: 'Contact Us',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit'
  },
  termsAndConditionsPage:{
    title: 'Terms and Conditions',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit'
  }

}



// WEBPACK FOOTER //
// ./src/i18n/locales/es.js